import { render, staticRenderFns } from "./issue_note_graphql.vue?vue&type=template&id=654d4d3e&"
import script from "./issue_note_graphql.vue?vue&type=script&lang=js&"
export * from "./issue_note_graphql.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports